/* Enhance registered Globo fields; leave submission and validation to the app. */
(function () {
  const field = (form, name) => form.querySelector('[name="' + name + '"]');
  const control = input => input?.closest('.globo-form-control');
  const owned = new WeakMap();
  let currentContext = null, frame = 0;
  function setContextValue(input, value) {
    if (!input) return;
    const previous = owned.get(input);
    if (previous?.context === currentContext.name + '|' + currentContext.type && input.value !== previous.value) return;
    if (input.value !== value) {
      input.value = value;
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
    owned.set(input, { context: currentContext.name + '|' + currentContext.type, value });
  }
  function enhance() {
    frame = 0;
    document.querySelectorAll('.globo-form-app[data-id="123677"],.globo-form-app[data-id="124861"],.globo-form-app[data-id="119690"]').forEach(app => {
      app.classList.add('ag-managed-form');
      const form = app.querySelector('form');
      if (!form) return;
      const message = field(form, 'textarea'), type = field(form, 'select-1');
      const product = app.dataset.id === '123677' ? field(form, 'text-3') : null;
      const rental = app.dataset.id === '123677' ? field(form, 'text-4') : null;
      const messageControl = control(message);
      // Move real registered controls so keyboard and visual reading order agree.
      [type, product, rental].forEach(input => {
        const item = control(input);
        if (item && messageControl && item.parentElement === messageControl.parentElement && (item.compareDocumentPosition(messageControl) & Node.DOCUMENT_POSITION_PRECEDING)) {
          messageControl.before(item);
        }
      });
      const email = field(form, 'email');
      if (email) { email.setAttribute('autocomplete', 'email'); email.setAttribute('inputmode', 'email'); }
      const name = field(form, 'text-1');
      if (name) name.setAttribute('autocomplete', 'name');
      const phone = field(form, 'phone-1');
      if (phone) { phone.setAttribute('autocomplete', 'tel'); phone.setAttribute('inputmode', 'tel'); }
      const company = field(form, 'text-2');
      if (company) company.setAttribute('autocomplete', 'organization');
      if (currentContext && app.dataset.id === '123677' && app.closest('#ag-inquiry')) {
        setContextValue(product, currentContext.name);
        setContextValue(field(form, 'hidden-1'), currentContext.name);
        setContextValue(type, currentContext.type);
      }
    });
  }
  function schedule() { if (!frame) frame = requestAnimationFrame(enhance); }
  document.addEventListener('ag:inquiry-open', event => {
    currentContext = event.detail;
    enhance();
  });
  const observer = new MutationObserver(schedule);
  function start() { observer.observe(document.body, { childList: true, subtree: true }); enhance(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true }); else start();
})();
